import { useEffect, useRef } from 'react'
import {
  useInView,
  useMotionValue,
  useSpring,
  useReducedMotion,
} from 'framer-motion'

export function NumberTicker({
  value,
  className,
  decimalPlaces = 0,
  delay = 0,
}) {
  const ref = useRef(null)
  const reduce = useReducedMotion()
  const motionValue = useMotionValue(0)
  const spring = useSpring(motionValue, { damping: 60, stiffness: 100 })
  const inView = useInView(ref, { once: true, margin: '0px' })

  useEffect(() => {
    if (reduce || !inView) return
    const timer = setTimeout(() => motionValue.set(value), delay * 1000)
    return () => clearTimeout(timer)
  }, [inView, value, delay, motionValue, reduce])

  useEffect(() => {
    if (reduce) return
    return spring.on('change', (latest) => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat('en-US', {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
        }).format(Number(latest.toFixed(decimalPlaces)))
      }
    })
  }, [spring, decimalPlaces, reduce])

  return (
    <span ref={ref} className={className}>
      {reduce ? Intl.NumberFormat('en-US').format(value) : '0'}
    </span>
  )
}
